import React from 'react';

import { Button, Space } from '@sravni/react-design-system';
import pluralize from '@sravni/utils/lib/pluralize';

interface IProps {
  onShowMore: () => void;
  moreAnswers: number;
  type?: 'answers' | 'comments';
  loading?: boolean;
}

export const ShowMoreButton: React.FC<IProps> = ({ onShowMore, moreAnswers, loading = false, type = 'comments' }) => {
  return (
    <Space className={'h-mt-32'}>
      <Button onClick={onShowMore} size={60} variant={'secondary'} color={'blue'} block loading={loading}>
        {type === 'answers'
          ? `Показать ответы (${moreAnswers})`
          : `Показать ещё ${moreAnswers} ${pluralize(moreAnswers, 'комментарий', 'комментария', 'комментариев')}`}
      </Button>
    </Space>
  );
};
